import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_DEP_PAID_BEGIN = "FETCH_DEP_PAID_BEGIN"
export const FETCH_DEP_PAID_SUCCESS = "FETCH_DEP_PAID_SUCCESS"
export const FETCH_DEP_PAID_ERROR = "FETCH_DEP_PAID_ERROR"

export const fetchDepPaidBegin = () => {
	return async (dispatch) => {
		dispatch({
			type: FETCH_DEP_PAID_BEGIN,
		})
		return Promise.resolve()
	}
}

export const fetchDepPaidError = (error) => {
	return async (dispatch) => {
		dispatch({
			type: FETCH_DEP_PAID_BEGIN,
			payload: { error },
		})
		return Promise.resolve()
	}
}

export const fetchDepPaidSuccess = (depPaid) => {
	return async (dispatch) => {
		dispatch({
			type: FETCH_DEP_PAID_SUCCESS,
			payload: { depPaid },
		})
		return Promise.resolve()
	}
}

export function fetchDepPaid(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepPaidBegin())
		return fetch(`${URL}api/atelierextras?case=0&id=${data.id}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchDepPaidSuccess(json)))
			.catch(catchApiError(dispatch, fetchDepPaidError, { silent: true }))
	}
}

export const POST_DEP_PAID_BEGIN = "POST_DEP_PAID_BEGIN"
export const POST_DEP_PAID_ERROR = "POST_DEP_PAID_ERROR"
export const POST_DEP_PAID_SUCCESS = "POST_DEP_PAID_SUCCESS"
export const POST_DEP_PAID_RESET = "POST_DEP_PAID_RESET"

export const postDepPaidBegin = () => {
	return async (dispatch) => {
		dispatch({
			type: POST_DEP_PAID_BEGIN,
		})
		return Promise.resolve()
	}
}

export const postDepPaidError = (error) => {
	return async (dispatch) => {
		dispatch({
			type: POST_DEP_PAID_ERROR,
			payload: { error },
		})
		return Promise.resolve()
	}
}

export const postDepPaidSuccess = () => {
	return async (dispatch) => {
		dispatch({
			type: POST_DEP_PAID_SUCCESS,
		})
		return Promise.resolve()
	}
}

export const postDepPaidReset = () => {
	return async (dispatch) => {
		dispatch({
			type: POST_DEP_PAID_RESET,
		})
		return Promise.resolve()
	}
}

export function postDepPaid(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDepPaidBegin())
		return fetch(`${URL}api/atelierextras`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then(() => dispatch(postDepPaidSuccess()))
			.catch(catchApiError(dispatch, postDepPaidError, { silent: true }))
	}
}
